import axios from 'axios';
import { EventBus } from '../eventBus/nav-bar-event';
const { uuid } = require('uuidv4');
export default {
    data(){
        return {
            upload_in_progress: false,
            attachment_file:"",
            download_url:"",
            check_attachments: false,
            input_file:[]
        }
    },
    methods: {
        uploadAttachment(e) {
            var input = e.target;
            if (input.files && input.files[0]) {
                // if(input.files[0].type == 'xls/xlsx') {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    if (this.attachments.length >= 1) {
                        this.warning_msg = "You're not allowed to upload more than 1 attachments"
                        this.$refs.warning_modal.open();
                        this.attachments = []
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    } else if(input.files[0].size > 10240*1024) {
                        this.warning_msg = "File size can't be greater than 10 MB";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    } else {
                        if(input.files[0].size <=0) {
                            this.warning_msg = "Please upload valid file.";
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.$refs.warning_modal.close();
                            }, 3000);
                        } else {
                            this.attachments.push(attachment)
                            this.getResumableURL(input.files[0], this.attachments[this.attachments.length - 1]);
                        }
                    }
                // } else {
                //     this.warning_msg = "Please upload supported file formats only.";
                //     this.$refs.warning_modal.open();
                //     setTimeout(() => {
                //         this.$refs.warning_modal.close();
                //     }, 3000);
                // }
            }
        },
        getResumableURL(file, attachment) {
            this.upload_in_progress = true;
            let data = {
                file: attachment.name,
            };
            // this.edit_user_data.signature_details.size = attachment.size;
            data = new FormData();
            data.append("file", file);
            attachment.uploading = true;
            this.$http
                .post("https://cloudapis.digicollect.com/external/upload_file",data, {
                    onUploadProgress: (progressEvent) => {
                        let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                            .total));
                        if (progress < 100) {
                            attachment.progress = progress;
                        }
                    }
                })
                .then(response => {
                    if (response.data.status_id == 1) {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        if (response.data.hasOwnProperty('reason')){
                            attachment.error = "Error Uploading"
                            if (attachment.url == undefined) {
                                this.check_attachments = true
                            } else {
                                this.check_attachments = false
                            }
                        }
                        this.upload_in_progress = false;
                    } else {
                        this.warning_msg = 'File Upload Failed.';
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                            this.upload_in_progress = false;
                        }, 3000);
                    }
                })
                .catch(error => {
                    this.warning_msg = 'File Upload Failed.';
                    this.$refs.warning_modal.open();
                    this.attachments = []
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                    this.upload_in_progress = false;
                    this.uploaded_file_data_for_scan = null;
                    this.save_api_in_progress = false;
                    this.file_upload_success = false;
                    this.cloud_file_upload_success = false;
                });
        },
        downloadAttachment(attachment){
            this.download_url = attachment.url
            var a = document.createElement('a');
            a.href = this.download_url;
            a.download = attachment.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        uploadAttachmentInsideFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    id: uuid(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.attachments.push(attachment)
                if (this.attachments.length > 1) {
                    this.warning_msg = "You're not allowed to upload more than 1 attachments"
                    this.$refs.warning_modal.open();
                    this.attachments = []
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                } else {
                    this.getResumableURL(input, this.attachments[this.attachments.length - 1]);
                }
            }
        },
    },
    computed:{
        error(){
            return ""
        }
    },
}    



// WEBPACK FOOTER //
// ./src/components/mixins/bulkAttachments.js